import { z } from 'zod/v4';

export const globalVehicleSchema = z.object({
  accountId: z.number(),
  accountName: z.string(),
  id: z.number(),
  vehicleId: z.string(),
  vehicleName: z.string(),
});

export type GlobalVehicle = z.infer<typeof globalVehicleSchema>;
